import(/* webpackMode: "eager" */ "/workspace/src/app/layout.js");
